export const colors = {
  colors: {
    navy: '#000080',
    aqua: '#00FFFF',
    black: '#000000',
    white: '#FFFFFF',
    grey: {
      '500': '#6B7280',
      '900': '#212121',
    },
    'light-blue': {
      '100': '#B3E5FC',
      '300': '#4FC3F7',
      '900': '#01579B',
    },
    teal: {
      '700': '#00796B',
      '900': '#004D40',
    },
  },
  backgroundImage: () => ({
    'piano-pattern': `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='70' height='46' viewBox='0 0 70 46'%3E%3Cg fill-rule='evenodd'%3E%3Cg fill='%23000000' fill-opacity='0.4'%3E%3Cpolygon points='68 44 62 44 62 46 56 46 56 44 52 44 52 46 46 46 46 44 40 44 40 46 38 46 38 44 32 44 32 46 26 46 26 44 22 44 22 46 16 46 16 44 12 44 12 46 6 46 6 44 0 44 0 42 8 42 8 28 6 28 6 0 12 0 12 28 10 28 10 42 18 42 18 28 16 28 16 0 22 0 22 28 20 28 20 42 28 42 28 28 26 28 26 0 32 0 32 28 30 28 30 42 38 42 38 0 40 0 40 42 48 42 48 28 46 28 46 0 52 0 52 28 50 28 50 42 58 42 58 28 56 28 56 0 62 0 62 28 60 28 60 42 68 42 68 0 70 0 70 46 68 46'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
    'demo-menu': 'linear-gradient(to right, #a855f7, #6366f1)',
    'demo-listbox': 'linear-gradient(to right, #fcd34d, #f97316)',
    'demo-switch': 'linear-gradient(to right, #4ade80, #06b6d4)',
    'demo-disclosure': 'linear-gradient(to right, #d946ef, #9333ea)',
    'demo-dialog': 'linear-gradient(to right, #38bdf8, #6366f1)',
    'demo-popover': 'linear-gradient(to right, #fb923c, #db2777)',
    'demo-radiogroup': 'linear-gradient(to right, #22d3ee, #0ea5e9)',
    'demo-tabs': 'linear-gradient(to right, #38bdf8, #2563eb)',
    popup: 'rgba(29, 25, 41, 0.5)',
  }),
};
